"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const link_1 = __importDefault(require("@kyruus/link"));
const messages_1 = __importDefault(require("../../lib/messages"));
const styles_1 = require("./styles");
const tracking_utils_1 = require("../../lib/tracking.utils");
const utils_1 = require("../../lib/utils");
const ProfileContact = ({ provider, track }) => {
    const phoneNumber = (0, utils_1.getProviderPhone)(provider);
    const contactAnchor = (val) => (react_1.default.createElement(link_1.default, { href: `tel:${val}`, onClick: () => (0, tracking_utils_1.trackingProfileContact)(track, 'phone', provider.id) }, val));
    // do not render component when neither phone nor request URL exists
    if (!phoneNumber) {
        return null;
    }
    return (react_1.default.createElement(styles_1.ContactSection, { "data-testid": "profile-contact" },
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.profileContactWithPhoneOnly, { values: {
                phone: phoneNumber && contactAnchor(phoneNumber)
            } }))));
};
exports.default = ProfileContact;
//# sourceMappingURL=profile-contact.js.map